import getSanityLocaleDocumentQuery from '@otovo/shared/lib/getSanityLocaleDocumentQuery';
import { Cloud$BusinessUnitConfig } from '@otovo/shared/types/cloudApi';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { Sanity$Query } from '@otovo/shared/types/sanityTypes';

export function getAllLocatorPagesQuery(
  buConfig: Cloud$BusinessUnitConfig,
  locale: Otovo$Locale | undefined,
): Sanity$Query {
  const localeQuery = getSanityLocaleDocumentQuery({ locale, buConfig });
  const { market } = buConfig;
  return {
    queryString: /* groq */ `*[_type == 'locatorPage' && activeFrom <= now()
    ${localeQuery}
    && references("market-${market}")] | order(priority asc, title asc){
      ...,
      mainImage{
        ...,
        asset->{
          ...,
          metadata
        }
      },
      _id,
      "slug": slug.current,
      "noindex": meta.noindex,
      'locale': language,
    }`,
  };
}
